import axios from 'axios';

const apiRequest = axios.create({
  baseURL: `${process.env.VUE_APP_API_HOST}/api/`,
});

apiRequest.interceptors.request.use((x) => {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken) {
    // eslint-disable-next-line no-param-reassign
    x.headers.Authorization = `Bearer ${accessToken}`;
  }

  return x;
}, (e) => Promise.reject(e));

apiRequest.interceptors.response.use(undefined, (err) => new Promise(() => {
  // eslint-disable-next-line no-underscore-dangle
  if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
    if (this.$route.name !== 'Home') {
      this.$router.replace({ name: 'Home' });
    }
  }
  throw err;
}));

export const getVideos = (data) => apiRequest.get('/videos', data);
export const getVideoById = (videoId, data) => apiRequest.get(`/video/${videoId}`, data);
export const getRelatedVideos = (videoId) => apiRequest.get(`/video/${videoId}/related`);
export const homeList = (data) => apiRequest.get('/home', data);

export const getTagBySlug = (tagSlug, data) => apiRequest.get(`/tags/slug/${tagSlug}`, data);
export const getTags = (queryString, data) => apiRequest.get('/tags', data);

export const searchByKeyWord = (keyWord, data) => apiRequest.get(`/searches/${keyWord}`, data);

export const getScenarios = (data) => apiRequest.get('/scenarios', data);
export const getScenarioById = (scenarioId, data) => apiRequest.get(`/scenarios/${scenarioId}`, data);

export const getFavoriteVideos = (data) => apiRequest.get('/videos/favorited/', data);
export const getFavoriteStatus = (videoId) => apiRequest.get(`/video/${videoId}/favorited`);
export const removeFavoriteVideo = (videoId) => apiRequest.delete(`/video/${videoId}/favorited`);
export const addFavoriteVideo = (videoId) => apiRequest.put(`/video/${videoId}/favorited`);

export const getUserInfo = (userId) => apiRequest.get(`/user/${userId}`);
export const getMyInfo = () => apiRequest.get('/user/me');
